import { useRealtimeEvents } from '../context/RealtimeEventsContext';

/**
 * Hook to access game scores from the realtime events stream
 *
 * @param gameId - Optional game ID to get score for a specific game
 * @returns Game scores data and connection status
 *
 * @example
 * // Get all game scores
 * const { gameScores, isConnected } = useGameScores();
 *
 * @example
 * // Get a specific game's score
 * const { gameScore, isConnected } = useGameScores('game-123');
 */
export const useGameScores = (gameId?: string) => {
  const { gameScores, isConnected, getGameScore } = useRealtimeEvents();

  // If a specific game ID is provided, return just that game's data
  if (gameId) {
    return {
      gameScore: getGameScore(gameId),
      isConnected,
    };
  }

  // Otherwise, return all game scores
  return {
    gameScores,
    isConnected,
  };
};

export default useGameScores;
